{
  "title": "Bon retour",
  "subtitle": {
    "email": "Se connecter à votre compte",
    "password": "Entrez votre mot de passe",
    "magicLink": "Nous vous enverrons un lien de connexion",
    "setupPassword": "Créer votre mot de passe"
  },
  "buttons": {
    "loginMicrosoft": "Se connecter avec Microsoft",
    "loginMagicLink": "Connexion par lien magique",
    "usePassword": "Utiliser un mot de passe (cas particuliers uniquement)",
    "login": "Connexion",
    "changeEmail": "Modifier l'e-mail",
    "forgotPassword": "Mot de passe oublié ?",
    "setupPassword": "Créer un mot de passe",
    "sendLoginLink": "Envoyer le lien"
  },
  "fields": {
    "email": "E-mail",
    "password": "Mot de passe"
  },
  "errors": {
    "enterEmail": "Veuillez entrer votre adresse e-mail",
    "enterPassword": "Veuillez entrer votre mot de passe",
    "invalidCredentials": "E-mail ou mot de passe incorrect",
    "notWhitelisted": "L'authentification par mot de passe n'est pas disponible pour votre compte. Veuillez utiliser Microsoft ou Google pour vous connecter.",
    "genericError": "Une erreur s'est produite. Veuillez réessayer."
  },
  "messages": {
    "passwordRestricted": "L'authentification par mot de passe est restreinte selon la politique de votre organisation. La plupart des utilisateurs doivent utiliser la connexion Microsoft ou Google ci-dessus.",
    "setupRequired": "Votre compte est approuvé pour l'authentification par mot de passe. Veuillez définir un mot de passe pour continuer.",
    "noPasswordSet": "Aucun mot de passe défini pour ce compte. Vous pouvez vous connecter à l'aide d'un lien magique envoyé à votre e-mail, ou contacter votre administrateur pour configurer l'authentification par mot de passe.",
    "magicLinkTooltip": "La connexion par lien magique permet de se connecter en toute sécurité sans mot de passe. Un lien sera envoyé à l'adresse e-mail associée à votre compte."
  },
  "magicLinkPage": {
    "title": "Se connecter avec un lien magique",
    "description": "Entrez votre adresse e-mail ci-dessous pour recevoir un lien de connexion.",
    "emailLabel": "E-mail",
    "sendButton": "Envoi",
    "successTitle": "Vérifiez votre e-mail",
    "successMessage": "Un e-mail avec le sujet <u>Connexion à AirPlx</u> a été envoyé à <u>{{email}}</u>. Cliquez sur le lien pour vous connecter."
  }
}
